import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { apiSDKService } from "../api/renewal/api.service";
import { PAGE_NAMES, PAGE_NAMES_MAIN } from "../constant/page-view";

const getOrCreateSessionId = () => {
  let sessionId = sessionStorage.getItem("session_id");

  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem("session_id", sessionId);
  }

  return sessionId;
};

export const getPageNameFromUrl = (pathname) => {
  if (
    String(pathname) === PAGE_NAMES_MAIN.paths[0] ||
    String(pathname) === PAGE_NAMES_MAIN.paths[1]
  ) {
    return PAGE_NAMES_MAIN.name;
  }

  const matchedPage = Object.entries(PAGE_NAMES).find(([_, pageInfo]) =>
    pageInfo.paths.some((path) => pathname.startsWith(path))
  );

  return matchedPage ? matchedPage[1].name : PAGE_NAMES_MAIN.name;
};

export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const sessionId = getOrCreateSessionId();
    const enterTime = new Date();
    const pagePath = `${location.pathname}${location.search || ""}`;
    const pageCategory = getPageNameFromUrl(location.pathname);
    let isUpdated = false;

    const trackPageView = async () => {
      try {
        await apiSDKService.createPageView({
          sessionId,
          pageCategory,
          pagePath,
          contentTitle: document.title,
          enterTime,
        });
      } catch (error) {
        console.error("Page view create failed:", error);
      }
    };

    const updatePageView = async ({ keepalive = false } = {}) => {
      if (isUpdated) {
        return;
      }

      isUpdated = true;

      const exitTime = new Date();
      const stayDurationMs = exitTime.getTime() - enterTime.getTime();

      try {
        await apiSDKService.updatePageView(
          {
            sessionId,
            pagePath,
            exitTime,
            stayDurationMs,
          },
          { keepalive }
        );
      } catch (error) {
        if (!keepalive) {
          console.error("Page view update failed:", error);
        }
      }
    };

    const handlePageHide = () => {
      updatePageView({ keepalive: true });
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        updatePageView({ keepalive: true });
      }
    };

    trackPageView();
    window.addEventListener("pagehide", handlePageHide);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("pagehide", handlePageHide);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      updatePageView();
    };
  }, [location.pathname, location.search]);
};
